<template>
  <div>
    <div class="fixFast" v-if="configData.kefu_qrcode">
      <div class="fixFastQrCode"><img :src="configData.kefu_qrcode" /></div>
      <div class="fixFastRow">
        <a href="/contact">
          <div class="fixFastPic"><img src="@/assets/images/fixLogo.gif" /></div>
        </a>
        <!-- <div class="fixFastText">我要合作</div> -->
      </div>
    </div>
    <div class="header" ref="header" :class="{'fix-nav': headerShow == 2, 'headerOn':headerShow == 1, 'headerOff': headerShow == 0 }">
      <div class="headerKw"  @mouseleave="searchActive = false">
        <div class="headerLeft">
          <a href="/" class="headerLogo"><img :src="configData.logo || require('@/assets/images/logo.png')" /></a>

        </div>
        <div class="headerNav">
          <div class="navBox">
            <ul>
              <li class="navBoxItem" @mouseenter="navHover($event)">
                <a href="/" class="headerNavBtn">首页</a>
              </li>
              <li v-for="(item,index) in configData.nav" class="navBoxItem" @mouseenter="navHover($event)">
                <a :href="item.url || '/article/'+item.id" class="headerNavBtn">{{item.name}}</a>
                <div class="headerNavSon" :style="{width:sonWidht+'px'}">
                  <a :href="sonItem.url || '/article/'+sonItem.id" v-for="(sonItem,sonIndex) in item.childs" >
                    {{sonItem.name}}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="headerRight" >
          <div class="headerToolItem" ref="searchBox" >
            <a href="javascript:;" @click="searchActive = true" class="iconfont icon-sousuo headerToolItemIcon"></a>
            <div class="headerSearch" :class="{'searchActive':searchActive}" :style="{width:windowKw+'px',left:-searchBoxX+'px'}">
              <div class="headerSearchKw">
                <div class="headerSearchMain">
                  <div class="headerSearchBox">
                    <span class="headerSearchBoxTitle">Search</span>
                    <a href="javascript:;" title="点击搜索" @click="search" class="iconfont icon-sousuo headerSearchIcon"></a>
                    <input type="text" v-model="searchkey" @keyup.enter="search" class="headerSearchBoxInput" placeholder="输入关键词查询" />
                  </div>
                </div>
                <img src="@/assets/images/searchBg.png" class="headerSearchBg" />
              </div>
            </div>
          </div>
          <div class="headerToolItem headerToolItemPc">
            <a href="https://zc.ccccloud.cn/#/login?redirect=%2Findex" target="_blank" class="headerToolItemBtn">办公平台</a>
          </div>

          <div class="headerToolItem headerToolItemPhone">
            <a href="javascript:;" @click="phoneNavShow = !phoneNavShow" class="iconfont icon-ego-menu headerToolItemIcon"></a>
          </div>


          <div class="headerToolItem headerToolItemPc">
            <a href="javascript:;" @click="showFixPage = true" class="iconfont icon-ego-menu headerToolItemIcon"></a>
          </div>
        </div>
      </div>
    </div>


  <!-- pc弹出菜单 -->
    <div class="fixPage" :class="{'showFixPage':showFixPage}">
      <a href="javascript:;" @click="showFixPage = false" class="fixPageClose"><i class="iconfont icon-guanbi"></i></a>
      <div class="fixPageLeftBg"></div>
      <div class="fixPageRightBg"></div>
      <div class="fixPageLeft">
        <div class="fixPagePad">
          <img :src="homeData.first.pic_right" v-if="homeData.first" />

          <div class="fixPageQuickNav">
            网站访问快捷入口
            <div class="fixPageQuickNavLink">
              <a href="/userClass/client">客户</a>
              <a href="/userClass/investor">投资者</a>
              <a href="/userClass/collaborator">合作伙伴</a>
              <a href="/userClass/jobseeker">求职者</a>
            </div>
          </div>

          <div class="fixPageLeftFoot" style="color: #fff;">
            {{configData.slogan}}
          </div>
        </div>
      </div>
      <div class="fixPageRight">
        <div class="fixPageRightMain">
          <div class="fixPagePad">
            <div class="fixPageRightTop clearfix">
              <div class="fixPageRightFr">
                <div class="fixPageRightTel">{{configData.hotLine}}</div>

                  全国客户服务热线

              </div>
              <a href="https://zc.ccccloud.cn/#/login?redirect=%2Findex" target="_blank" class="fixPageRightTopBtn"><i class="iconfont icon-bangongpingtai"></i>办公平台</a>
            </div>

            <div class="fixPageLink">
              <div class="fixPageLinkItem" v-for="(item,index) in configData.nav">
                <div class="fixPageLinkItemTitle"><a :href="item.url">{{item.name}}</a></div>
                <div class="fixPageLinkItemSon">
                  <div v-for="itemSon,sonIndex) in item.childs"><a :href="item.url">{{itemSon.name}}</a></div>
                </div>
              </div>
            </div>

            <div class="fixPageFoot">
              <div class="fixPageFootItem">
                关注中瓷控股
                <div class="fixPageFootItemText">follow China holdings</div>
                <div class="fixPageFootItemIcon">
                  <a href="javascript:;" class="footerMediumIcon iconfont icon-weixin1" v-if="configData.wechat_qrcode" style="color: #2ac546;"><div class="footerMediumIconPic"><img :src="configData.wechat_qrcode" /></div></a>
                  <a href="javascript:;" class="footerMediumIcon iconfont icon-zhongci" v-if="configData.qrcode" style="color: #AD7C59;"><div class="footerMediumIconPic"><img :src="configData.qrcode" /></div></a>
                </div>
              </div>

              <div class="fixPageFootItem" v-html="configData.copyright"></div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- 移动端菜单 -->
    <div class="phoneNav wow animate__fadeIn" data-wow-duration=".5s" :class="{'active':phoneNavShow}">
      <a href="javascript:;" class="phoneNavClose" @click="phoneNavShow = false"><i class="iconfont icon-guanbi"></i></a>
      <div class="phoneNavBox">
        <div class="phoneNavBoxPad">
          <div class="phoneNavItem" v-for="(item,index) in configData.nav">
            <a href="javascript:;" class="phoneNavItemBtn" @click="navClick(index)">{{item.name}}</a>
            <div class="phoneNavSon" :class="{'active': item.open}">
              <div>
                <!-- <a :href="itemSon.url" v-for="(itemSon,sonIndex) in item.childs">{{itemSon}}{{itemSon.name}}</a> -->
                <a :href="sonItem.url || '/article/'+sonItem.id" v-for="(sonItem,sonIndex) in item.childs" >
                  {{sonItem.name}}
                </a>


              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="phoneNavFoot">
          致力于成为<br/>
          最受信赖健康文化信息服务商
          <div class="phoneNavFootText">
            Committed to becoming the most trusted health culture information service provider
          </div>

      </div>
    </div>
</div>

</template>

<script>
import { indexData } from '@/api/web'
export default {
  components:{
  },

  watch: {
    "$store.state.webConfig":{
      handler:function(newVal,oldVal){
        this.configData = newVal
      }
    },
    headerTop(newValue,oldValue){

    	// 等新值大于100的时候再做变化（优化一下）
    	if(newValue > 80 && this.headerTop!=''){
    		if(newValue > oldValue){
    			this.headerShow = 0

    		}else{
    			this.headerShow = 1

    		}
    	}

      if(newValue == 0){
        this.headerShow = 3
      }
    }
  },

  data () {
    return {
      headerTop:'',
      headerShow:3,
      searchkey:'',

      // navBarFixed: false,
      sonWidht:0,
      windowKw:0,
      searchBoxX:0,
      searchActive:false,
      showFixPage:false,
      switchActive:false,
      phoneNavShow:false,
      configData:this.$store.state.webConfig,
      homeData:{},
      nav:[]
    }
  },
  mounted() {

    indexData().then(res => {

      this.homeData = res.data

    })


    window.addEventListener('scroll', () => {
    	this.headerTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
    })


    this.resize()
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.resize);
  },
  destroyed() {
    // 移除事件监听

  },

  methods:{
    resize(){
      this.windowKw = window.innerWidth
      this.searchBoxX = this.$refs.searchBox.getBoundingClientRect().left
    },
    navHover(event){
      const rect = event.target.getBoundingClientRect();
      this.sonWidht = window.innerWidth - rect.left;
    },

    navSwitch(){
      this.areaNavOpen = !this.areaNavOpen
    },
    search(){
      this.$router.push({path:'/search',query: {keyword:this.searchkey}});
    },
    navClick(i){

      this.configData.nav[i].open = !this.configData.nav[i].open
      this.$forceUpdate()
    }

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/topBar.vue